<template>
  <el-dialog title="" width="1095px" class="no-header" :show-close="false" :visible="dialogVisible">
    <div class="header">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-for="(item, nn) in tabList" :key="nn" :name="item.name">
          <span slot="label">{{ item.title }}({{ item.num }})</span>
        </el-tab-pane>
      </el-tabs>
      <i class="ficon ficon-guanbi1 close-btn" @click="cancelFun"></i>
    </div>
    <div class="image-view">
      <div class="swiper-wraper">
        <swiper ref="swiperTop" class="swiper" :options="swiperOptions" @slideChange="onSlideChange">
          <swiper-slide v-for="(childImage, cIndex) in imgs" :key="`swiper__item__${Tkey + cIndex}`">
            <img class="w-full object-contain" :src="childImage.original" />
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev" />
          <div class="swiper-button-next" slot="button-next" />
        </swiper>
        <div class="swiper-thumbs" ref="swiperThumbs">
          <div class="swiper-slide" v-for="(childImage, cIndex) in imgs" :key="`swiper__thumb__${Tkey + cIndex}`"
            @click="handleClickSwiperThumb(cIndex)" :class="{ 'swiper-slide-active': cIndex === SwiperThumbIndex }">
            <img class="w-full h-full object-cover" :src="childImage.mid" fit="cover" />
          </div>
        </div>
      </div>
      <div class="image-view-content">
        <div class="title">
          {{ imgInfo.name }}
          <em v-if="!!imgInfo.images_num">({{ imgInfo.images_num }})</em>
        </div>
        <div class="desc">{{ imgInfo.introduction }}</div>
      </div>
      <v-loading :active="loading"></v-loading>
    </div>
  </el-dialog>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";
import { getCruiseImages } from "@/services/company";

import { TABS } from "@/constants/galleryEnum";

export default defineComponent({
  name: "ImagePreviewView",
  auth: false,
  components: {},
  data() {
    return {
      Tkey: Date.now(),
      swiperOptions: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 1,
        spaceBetween: 0,
      },
      dialogVisible: false,
      tabList: [], //切换数据
      activeName: "",
      imgs: [], //图片
      imgInfo: {
        name: "",
        floor: "",
        consumption: "",
        capacity: "",
        open_time: "",
        introduction: "",
        images_num: "",
      },
      selectImagePath: "", //上面图片索引
      SwiperThumbIndex: 0, //swiper缩率图 索引
      loading: false,
    };
  },
  methods: {
    async setData(tabItemName, imgPath, cruiseId, cruise_images) {
      this.dialogVisible = true;
      this.imageData =
        !!cruise_images && cruise_images.length
          ? cruise_images
          : await this.getGalleryData(cruiseId);

      this.tabList = this.imageData.map((item) => {
        let { name } = TABS.find((items) => items.title === item.title);
        return {
          title: item.title,
          num: item.num,
          name,
        };
      });
      this.activeName = tabItemName || this.tabList[0].name;
      this.selectImagePath = imgPath;
      await this.handleClick();
    },
    async getGalleryData(cruise) {
      const { code, data } = await getCruiseImages({
        cruise,
      });
      if (code !== 10000) {
        return false;
      }

      return data.images;
    },
    handleClick() {
      this.loading = true;
      this.imgs = [];
      let { title } = TABS.find((items) => items.name === this.activeName);
      let { list } = this.imageData.find((item) => item.title === title);
      if (this.activeName !== "appearance") {
        let tempList = []; //获取把list数据合并成一个新数组
        let tempImgList = []; //将新数组中图片合并一个新一维数组
        list.forEach((item) => {
          tempList.push(...item[this.activeName]);
        });
        tempList.forEach((item) => {
          var item11 = item;
          let ImgList = item.images.map((items) => {
            return {
              ...items,
              introduction: item11.introduction,
            };
          });
          tempImgList.push(...ImgList);
        });
        this.imgs = tempImgList;
      } else {
        let tempList = [];
        list.forEach((item) => {
          tempList.push({ ...item.url });
        });
        this.imgs = tempList;
      }
      //判断传入图片路径是否存着
      if (!!this.selectImagePath) {
        let imgFindIndex = this.imgs.findIndex(
          (item) => item.mid === this.selectImagePath
        );
        this.SwiperThumbIndex = imgFindIndex > 0 ? imgFindIndex : 0;
      } else {
        this.SwiperThumbIndex = 0;
      }

      this.$nextTick(() => {
        this.$refs.swiperTop.$swiper.slideTo(this.SwiperThumbIndex);
        this.onSlideChange();
      });
      setTimeout(() => {
        this.loading = false;
      }, 600);
    },
    cancelFun() {
      this.dialogVisible = false;
    },
    onSlideChange() {
      let activeIndex = this.$refs.swiperTop.$swiper.activeIndex;
      this.SwiperThumbIndex = activeIndex;
      let {
        name,
        floor,
        consumption,
        capacity,
        open_time,
        introduction,
        images_num,
      } = this.imgs[activeIndex];

      Object.assign(this.imgInfo, {
        name,
        floor,
        consumption,
        capacity,
        open_time,
        introduction,
        images_num,
      });
      this.onScrollView();
    },
    //切换缩率图样式
    handleClickSwiperThumb(index) {
      this.SwiperThumbIndex = index;
      this.$refs.swiperTop.$swiper.slideTo(index);
    },
    //滚动视图
    onScrollView() {
      if (this.imgs.length <= 4) {
        return false;
      }

      let tempIndex = this.SwiperThumbIndex < 0 ? 0 : this.SwiperThumbIndex - 1;
      this.$refs.swiperThumbs.scrollTop = tempIndex * 130;
    },
  },
});
</script>
<style lang="scss">

.no-header {

  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
  }
}

</style>
<style lang="scss" scoped>
@import "~@/assets/scss/base/_color.scss";
::v-deep .no-header .el-dialog__header, ::v-deep .no-header .el-dialog__body {
  padding: 0;
}
::v-deep .header {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 68px;
  line-height: 68px;
  padding-left: 40px;
  padding-right: 40px;
  position: relative;
  width: 100%;
  border-bottom: 1px solid #e6e6e6;
}
::v-deep .header .close-btn {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  position: absolute;
  right: 20px;
  top: 22px;
  width: 32px;
}
::v-deep .header .close-btn::before {
  font-size: 32px;
}
::v-deep .header .el-tabs__item {
  padding-right: 30px;
  padding-left: 0;
  font-size: 16px;
}
::v-deep .el-tabs__nav-wrap:after {
  height: 0;
}
.image-view {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 40px;
  padding-right: 40px;
  width: 100%;
}
.image-view .swiper-wraper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  width: 100%;
}
.image-view .swiper-wraper .swiper {
  height: 526px;
  margin: 0px;
  width: 786px;
}
.image-view .swiper-wraper .swiper .swiper-slide {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 526px;
}
.image-view .swiper-wraper .scroll-bar-wrapper {
  margin: 0px;
  width: 198px;
}
.image-view .swiper-wraper .swiper-thumbs {
  height: 528px;
  margin: 0px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 198px;
}
.image-view .swiper-wraper .swiper-thumbs .swiper-slide {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  border-style: solid;
  border-width: 2px;
  cursor: pointer;
  height: 131px;
  width: 100%;
}
.image-view .swiper-wraper .swiper-thumbs .swiper-slide-active {
  --tw-border-opacity: 1;
  border-color: rgba(0, 94, 220, var(--tw-border-opacity));
  border-style: solid;
  border-width: 2px;
}
.swiper-button-prev, .swiper-button-next {
  height: 60px;
  width: 60px;
  background-size: 100% 100%;
}
.swiper-button-prev {
  background: url("@/assets/img/company/cruise-gallery/left.png") no-repeat center center;
}
.swiper-button-next {
  background: url("@/assets/img/company/cruise-gallery/right.png") no-repeat center center;
}
.swiper-button-prev:after, .swiper-button-next:after {
  content: "";
}
.title {
  margin-top: 20px;
  font-size: 28px;
  color: $important-text-color;
  font-weight: 500;
}
.desc {
  margin-top: 10px;
  white-space: pre-line;
  font-size: 14px;
  font-weight: 400;
}
::v-deep .v-loading-background {
  opacity: 0;
}
</style>
